import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LeafletGroupComponent } from '@components/leaflet/group/group.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import {
  Geologists,
  Expeditions,
} from '@models'

@Component({
  selector: 'app-geology-sample-filter',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  imports: [
    LeafletGroupComponent,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class GeologicalSampleFilterComponent {
  // Enums
  geologistList = Geologists;
  expeditionList = Expeditions;

  // Dialog
  dialogRef = inject<MatDialogRef<GeologicalSampleFilterComponent>>(MatDialogRef);

  // GeoJSON
  location: GeoJSON.FeatureCollection | undefined;

  // Form
  filterForm: FormGroup;

  expedition: FormControl;
  geologist: FormControl;
  geojson: FormControl;

  constructor() {
    const data = inject<{
      expedition: string,
      geologist: string,
      geojson: GeoJSON.FeatureCollection | undefined,
    }>(MAT_DIALOG_DATA);

    this.location = data?.geojson;

    this.expedition = new FormControl(data?.expedition || undefined);
    this.geologist = new FormControl(data?.geologist || undefined);
    this.geojson = new FormControl(data?.geojson || undefined);
    this.filterForm = new FormGroup({
      expedition: this.expedition,
      geologist: this.geologist,
      geojson: this.geojson,
    });
  }

  onGeoSearch(geometry: GeoJSON.FeatureCollection | undefined) {
    this.geojson.setValue(geometry);
    this.location = geometry;
    this.filterForm.markAsDirty();
  }

  submit() {
    if (!this.filterForm.valid) {
      return;
    }

    this.dialogRef.close({
      expedition: this.filterForm.value.expedition,
      geologist: this.filterForm.value.geologist,
      geojson: this.filterForm.value.geojson,
    });
  }
}
